import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Convert a 24h "HH:MM" string to a readable 12h "h:mm AM/PM" label.
// 00:30 -> 12:30 AM, 12:00 -> 12:00 PM. Does not alter stored values.
export function fmtTime(t) {
  if (!t) return "";
  const parts = String(t).split(":");
  let h = parseInt(parts[0], 10);
  const m = (parts[1] || "00").padStart(2, "0");
  if (isNaN(h)) return String(t);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${m} ${ampm}`;
}

// Format a stored "YYYY-MM-DD HH:MM" datetime into "DD Mon YYYY, h:mm AM/PM".
export function fmtDateTime(s) {
  if (!s) return "";
  const [d, t] = String(s).split(" ");
  const datePart = d
    ? new Date(d + "T00:00:00").toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
    : "";
  return t ? `${datePart}, ${fmtTime(t)}` : datePart;
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Resolve an image URL: external http(s) URLs are used as-is; internal
// "/api/..." paths (uploaded files) are prefixed with the backend URL.
export function resolveImg(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url) || url.startsWith("data:")) return url;
  return `${BACKEND_URL}${url}`;
}

// Extract a YouTube video id from watch, youtu.be, shorts or embed URLs.
export function youtubeId(url) {
  if (!url) return "";
  const u = String(url).trim();
  const patterns = [
    /youtube\.com\/shorts\/([A-Za-z0-9_-]{6,})/,
    /youtube\.com\/embed\/([A-Za-z0-9_-]{6,})/,
    /youtube\.com\/watch\?[^#]*v=([A-Za-z0-9_-]{6,})/,
    /youtu\.be\/([A-Za-z0-9_-]{6,})/,
    /youtube\.com\/live\/([A-Za-z0-9_-]{6,})/,
  ];
  for (const p of patterns) {
    const m = u.match(p);
    if (m) return m[1];
  }
  return "";
}

// Build an embeddable YouTube URL from any YouTube/Shorts/youtu.be link.
export function youtubeEmbed(url) {
  const id = youtubeId(url);
  return id ? `https://www.youtube.com/embed/${id}` : "";
}

// Auto-generate a YouTube thumbnail from a video URL.
export function youtubeThumb(url) {
  const id = youtubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : "";
}


